import { useContext } from 'react';
import { CompanyValuesContext } from '../CompanyProvider';

export const useCompanyValues = () => {
  const context = useContext(CompanyValuesContext);

  if (!context) {
    throw new Error('useCompanyValues must be used within a CompanyProvider');
  }

  return context;
};
